var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from '@emotion/styled';
export var VerticalGap = function (_a) {
    var size = _a.size;
    return _jsx(Gap, { direction: 'vertical', size: size });
};
export var HorizontalGap = function (_a) {
    var size = _a.size;
    return _jsx(Gap, { direction: 'horizontal', size: size });
};
var Gap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n"], ["\n  width: ", ";\n  height: ", ";\n"])), function (_a) {
    var direction = _a.direction, size = _a.size;
    return (direction === 'horizontal' ? "".concat(size, "px") : '100%');
}, function (_a) {
    var direction = _a.direction, size = _a.size;
    return (direction === 'vertical' ? "".concat(size, "px") : '100%');
});
var templateObject_1;
//# sourceMappingURL=Gap.js.map